module.exports = __webpack_public_path__ + "8c19503512ad29835c793fce5646960c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 258
 ** module chunks = 0
 **/